/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';

import type { AssignWorkOrderSpecialistsCommand } from '../models/AssignWorkOrderSpecialistsCommand';
import type { AttachedFileDto } from '../models/AttachedFileDto';
import type { CreateWorkOrderEmployeeVisitsCommand } from '../models/CreateWorkOrderEmployeeVisitsCommand';
import type { EmployeeVisitDto } from '../models/EmployeeVisitDto';
import type { OptimizeWorkOrderCommand } from '../models/OptimizeWorkOrderCommand';
import type { RejectWorkOrderCommand } from '../models/RejectWorkOrderCommand';
import type { RemoveWorkOrderEmployeeVisitsCommand } from '../models/RemoveWorkOrderEmployeeVisitsCommand';
import type { UpdateWorkOrderCommand } from '../models/UpdateWorkOrderCommand';
import type { UpdateWorkOrderEmployeeVisitsCommand } from '../models/UpdateWorkOrderEmployeeVisitsCommand';
import type { WorkOrderDto } from '../models/WorkOrderDto';
import type { WorkOrderIsNotMineCommand } from '../models/WorkOrderIsNotMineCommand';

import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

@Injectable({
  providedIn: 'root',
})
export class WorkOrdersService {

    constructor(public readonly http: HttpClient) {}

    /**
     * @param id 
     * @param version 
     * @returns WorkOrderDto Success
     * @throws ApiError
     */
    public getVWorkOrders(
id: number,
version: string,
): Observable<WorkOrderDto> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/v{version}/WorkOrders/{id}',
            path: {
                'id': id,
                'version': version,
            },
        });
    }

    /**
     * @param version 
     * @returns WorkOrderDto Success
     * @throws ApiError
     */
    public getVWorkOrders1(
version: string,
): Observable<Array<WorkOrderDto>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/v{version}/WorkOrders',
            path: {
                'version': version,
            },
        });
    }

    /**
     * @param version 
     * @param requestBody 
     * @returns WorkOrderDto Success
     * @throws ApiError
     */
    public putVWorkOrders(
version: string,
requestBody?: UpdateWorkOrderCommand,
): Observable<WorkOrderDto> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/v{version}/WorkOrders',
            path: {
                'version': version,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param id 
     * @param version 
     * @returns EmployeeVisitDto Success
     * @throws ApiError
     */
    public getVWorkOrdersEmployeeVisits(
id: number,
version: string,
): Observable<Array<EmployeeVisitDto>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/v{version}/WorkOrders/{id}/employeeVisits',
            path: {
                'id': id,
                'version': version,
            },
        });
    }

    /**
     * @param version 
     * @param requestBody 
     * @returns string Success
     * @throws ApiError
     */
    public postVWorkOrdersAssignWorkOrderSpecialists(
version: string,
requestBody?: AssignWorkOrderSpecialistsCommand,
): Observable<string> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/v{version}/WorkOrders/assignWorkOrderSpecialists',
            path: {
                'version': version,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param version 
     * @param requestBody 
     * @returns string Success
     * @throws ApiError
     */
    public postVWorkOrdersWorkOrderIsNotMine(
version: string,
requestBody?: WorkOrderIsNotMineCommand,
): Observable<string> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/v{version}/WorkOrders/workOrderIsNotMine',
            path: {
                'version': version,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param version 
     * @param requestBody 
     * @returns EmployeeVisitDto Success
     * @throws ApiError
     */
    public postVWorkOrdersCreateWorkOrderEmployeeVisits(
version: string,
requestBody?: CreateWorkOrderEmployeeVisitsCommand,
): Observable<Array<EmployeeVisitDto>> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/v{version}/WorkOrders/createWorkOrderEmployeeVisits',
            path: {
                'version': version,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }

    /**
     * @param version 
     * @param requestBody 
     * @returns EmployeeVisitDto Success
     * @throws ApiError
     */
    public postVWorkOrdersUpdateWorkOrderEmployeeVisits(
version: string,
requestBody?: UpdateWorkOrderEmployeeVisitsCommand,
): Observable<Array<EmployeeVisitDto>> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/v{version}/WorkOrders/updateWorkOrderEmployeeVisits',
            path: {
                'version': version,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param version 
     * @param requestBody 
     * @returns boolean Success
     * @throws ApiError
     */
    public postVWorkOrdersRemoveWorkOrderEmployeeVisits(
version: string,
requestBody?: RemoveWorkOrderEmployeeVisitsCommand,
): Observable<boolean> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/v{version}/WorkOrders/removeWorkOrderEmployeeVisits',
            path: {
                'version': version,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param version 
     * @param requestBody 
     * @returns boolean Success
     * @throws ApiError
     */
    public postVWorkOrdersOptimizeWorkOrder(
version: string,
requestBody?: OptimizeWorkOrderCommand,
): Observable<boolean> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/v{version}/WorkOrders/optimizeWorkOrder',
            path: {
                'version': version,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param version 
     * @param formData 
     * @returns boolean Success
     * @throws ApiError
     */
    public postVWorkOrdersFinishWorkOrder(
version: string,
formData?: {
WorkOrderId?: number;
Signatures?: Array<Blob>;
AttachedFiles?: Array<Blob>;
ClientSignerName?: string;
Observations?: string;
},
): Observable<boolean> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/v{version}/WorkOrders/finishWorkOrder',
            path: {
                'version': version,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }

    /**
     * @param version 
     * @param requestBody 
     * @returns boolean Success
     * @throws ApiError
     */
    public postVWorkOrdersRejectWorkOrder(
version: string,
requestBody?: RejectWorkOrderCommand,
): Observable<boolean> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/v{version}/WorkOrders/rejectWorkOrder',
            path: {
                'version': version,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param id 
     * @param version 
     * @returns AttachedFileDto Success
     * @throws ApiError
     */
    public getVWorkOrdersAttachedFiles(
id: number,
version: string,
): Observable<Array<AttachedFileDto>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/v{version}/WorkOrders/{id}/attachedFiles',
            path: {
                'id': id,
                'version': version,
            },
        });
    }

}
